import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/zeostability' },
    {
      path: '/', name: 'layout', component: () => import('@/layout/index'),
      children: [
        { path: '/introduction', component: () => import('@/page/introduction') },
        { path: '/zeostability', component: () => import('@/page/zeostability') },
        // Wulff ****************************************** 
        { path: '/zeowulff', name: 'wulff',  component: () => import('@/page/zeowulffdashboard'),},
        { path: "/zeowulff/:id", name: 'wulffTemplate', component: () => import('@/zeowulff/WulffTemplate'),},
        { path: "/zeowulffview/:id", name: 'wulffviewTemplate', component: () => import('@/zeowulff/WulffviewTemplate'),},
        // ********************************** */
        // acidity**********************
        { path: '/zeoacidity', name: 'zeoacidity', component: () => import('@/page/zeoaciditydashboard') },
        { path: "/zeoacidity/:id", name: 'zeoacidityTemplate', component: () => import('@/zeowulff/ZeoacidityTemplate'),},
        { path: "/zeoacidityview/:id", name: 'zeoacidityStructure', component: () => import('@/zeowulff/ZeoacidityStructure'),},
        //****************************** */
        // zeodoped**********************
        { path: '/zeodopedGe', name: 'zeodopedGe', component: () => import('@/page/zeodopedGedashboard') },
        { path: "/zeodopedGe/:id", name: 'ZeodopedGeStructure', component: () => import('@/zeowulff/ZeodopedGeStructure'),},
        //****************************** */
        // MPCD************
        { path: '/MPCD', name: 'MPCD', component: () => import('@/page/MPCD'),},
        { path: "/MPCD/search", name: 'MPCDsearch', component: () => import('@/zeowulff/MPCDsearch'),},
        { path: "/MPCD/:id", name: 'OrganicviewTemplate', component: () => import('@/zeowulff/OrganicviewTemplate'),},
        //********************* */
        { path: '/zpliu', component: () => import('@/page/zpliu') },
        { path: '/scma', component: () => import('@/page/scma') },
        { path: '/jobs', component: () => import('@/page/jobs') },
        // { path: '/exam', component: () => import('@/page/exam') },
      ]
    },
  ],
  scrollBehavior(to, from, savedPosition) { return { x: 0, y: 0 } }
});



// WEBPACK FOOTER //
// ./src/router/index.js